import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, OnDestroy, SimpleChanges, signal, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { FormatService } from '../../../services/format.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'myabvv-alert',
    standalone: true,
    templateUrl: './alert.component.html',
    imports: [NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertComponent implements OnInit, OnChanges, OnDestroy {
  private translateService = inject(TranslateService);
  private formatService = inject(FormatService);

  @Input() condition?: boolean;
  @Input() message?: string | null;       // <- can be undefined/null initially
  @Input() type?: string | null;
  @Input() icon?: string | null;
  @Input() redirectPath?: string | null;

  classType = '';
  translatedMessage = signal('');

  private langSub = new Subscription();

  ngOnInit() {
    if (this.type) this.classType = 'c-alert--' + this.type;

    this.langSub = this.translateService.onLangChange.subscribe({
      next: () => this.translateMessage(),
      error: (err: unknown) => console.error('[AlertComponent] Language change error:', err)
    });

    this.translateMessage();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['message'] || changes['redirectPath']) {
      this.translateMessage();
    }
  }

  ngOnDestroy(): void {
    this.langSub.unsubscribe();
  }

  private translateMessage(): void {
    const key = this.message?.trim();
    if (!key) {
      this.translatedMessage.set('');
      return;
    }

    this.translateService.get(key).pipe(take(1)).subscribe({
      next: (translatedText: string) => {
        this.translatedMessage.set(this.formatService
          .formatMessage(translatedText, [this.redirectPath ?? '']));
      },
      error: (err: unknown) => console.error('[AlertComponent] Error translating message:', err)
    });
  }
}
